import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {ShareLogModel} from '@/libs/Api';
import {ShareLogsDataService} from '@/libs/share-logs/share-logs-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const shareLogsStore = registerCrudStore<ShareLogModel, ShareLogModel>(StoreName.ShareLog, new ShareLogsDataService());
